import { __ } from '@wordpress/i18n';
import { Button, Spinner } from '@wordpress/components';

interface CancelBookingConfirmationProps {
	onConfirm: () => void;
	onCancel: () => void;
	isSubmitting?: boolean;
	error?: string | null;
}

export function CancelBookingConfirmation({
	onConfirm,
	onCancel,
	isSubmitting = false,
	error = null,
}: CancelBookingConfirmationProps) {
	return (
		<div className="gpb-cancel-booking-confirmation">
			<h3>{__('Cancel Booking', 'gp-bookings')}</h3>
			<p>
				{__(
					'Are you sure you want to cancel this booking?',
					'gp-bookings'
				)}
			</p>
			{error && <div className="gpb-cancel-booking-error">{error}</div>}
			<div
				className="gpb-cancel-booking-actions"
				style={{ display: 'flex', gap: '8px' }}
			>
				<Button
					variant="secondary"
					onClick={onCancel}
					disabled={isSubmitting}
				>
					{__('Keep booking', 'gp-bookings')}
				</Button>
				<Button
					variant="primary"
					isDestructive
					onClick={onConfirm}
					disabled={isSubmitting}
				>
					{isSubmitting ? (
						<Spinner />
					) : (
						__('Cancel booking', 'gp-bookings')
					)}
				</Button>
			</div>
		</div>
	);
}
